import { BranchUser } from './branch-user.model';

export class BranchUserSecurityQuestion {
  public Id: string;
  public BranchUserID: number;
  public SecurityQuestionCode: string;
  public Answer: string;
  public BranchUser: BranchUser;
}
